<template>
<div>
    <h3>Información General</h3>
    <div class="card" v-loading="loading" element-loading-text="Cargando..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
        <div class="card-body">
            <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Nombre del Evento</label>
                                    <input type="text" v-model="form.name" class="form-control" placeholder="Nombre del evento" />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Descripción (Opcional)</label>
                                    <input type="text" v-model="form.description" class="form-control" placeholder="Descripción del evento" />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Fecha del Evento</label>
                                    <input type="text" v-model="form.date" class="form-control" placeholder="Fecha del Evento" />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>Hora del Evento</label>
                                    <input type="text" v-model="form.hour" class="form-control" placeholder="Hora del evento" />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <label>Subir evento</label>
                                <el-upload class="picture-card" ref="courseUpload" action="" drag accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG, .webp, .WEBP, .avif, .AVIF" :on-change="onUploadChange" :http-request="submit" :multiple="false" :limit="1" :auto-upload="false" :file-list="fileList" :on-exceed="handleExceed">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text">
                                        Suelta tu archivo aquí o
                                        <em>haz clic para cargar</em>
                                    </div>
                                    <div slot="tip" class="el-upload__tip">
                                        Solo archivos jpg/png/webp con un
                                        tamaño menor de 500kb
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button type="submit" class="btn btn-success" :disabled="isSubmitting">
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            extensions: ".jpeg, .jpg, .png, .webp, .avif",
            form: {},
            products: [],
            fileList: [],
            isSubmitting: false,
            productsSelected: [],
            precioEstimado: 0,
        };
    },
    props: {
        event: Object,
    },
    watch: {
        event: function () {
            this.form = this.event;
            this.fillFiles();
        }
    },
    created() {
        this.initForm();
    },
    methods: {
        fillFiles() {
            this.fileList = [{
                name: this.event.filename,
                // url: `${this.offer.portada_url}`,
                raw: `${this.event.path}`,
            }, ];
        },
        handleExceed(file) {
            const isLt500kb = file.size > 800000;

            if (!isLt500kb) {
                this.$message.error("El archivo no debe pesar más de 800Kb!");
                this.$refs.courseUpload.clearFiles();
                return false;
            }
        },

        onUploadChange(file) {
            this.fileList = [];

            const isImage =
                file.raw.type === "image/jpeg" ||
                file.raw.type === "image/webp" ||
                file.raw.type === "image/png" ||
                file.raw.type === "image/avif" ||
                file.raw.type === "image/jpg";

            // 100kb
            const isLt1M = file.size < 800000;

            if (!isImage) {
                this.$message.error(
                    "Solo puede cargar archivos en formato jpg|jpeg|png."
                );
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            if (!isLt1M) {
                this.$message.error("El archivo no debe pesar más de 800Kb!");
                this.$refs.courseUpload.clearFiles();
                return false;
            }
            // let reader = new FileReader();
            // reader.readAsDataURL(file.raw);
            // reader.onload = function (e) {
            //   console.log(this.result);
            // };
            this.fileList.push(file);
        },

        initForm() {
            this.form = {
                name: null,
                description: null,
            };
        },
        hasEspecialCharacters(text) {
            // Solo puede contener vocales con tilde A-Z  y 0-9
            const regex = new RegExp(
                /^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g
            );
            return regex.test(text);
        },
        validateFields() {
            if (
                !this.form.name ||
                this.form.name.trim() === "" ||
                this.form.name.length === 0
            ) {
                this.$message.warning("Ingrese el nombre del evento!");
                return false;
            }

            if (this.form.name.length > 255) {
                this.$message.warning(
                    "El nombre del evento es demasiado largo!"
                );
                return false;
            }

            if (
                !this.form.date ||
                this.form.date.trim() === "" ||
                this.form.date.length === 0
            ) {
                this.$message.warning("Ingrese la fecha del evento!");
                return false;
            }

            if (
                !this.form.hour ||
                this.form.hour.trim() === "" ||
                this.form.hour.length === 0
            ) {
                this.$message.warning("Ingrese la hora del evento!");
                return false;
            }

            if (!this.$refs.courseUpload) {
                this.$message.warning(
                    "No ha seleccionado la imagen del evento!"
                );
                return false;
            }

            return true;
        },

        async submit() {
            if (this.validateFields()) {

                this.isSubmitting = true;
                const formdata = new FormData();
                formdata.append("id", this.event.id);
                formdata.append("name", this.form.name);
                formdata.append("description", this.form.description);
                formdata.append("date", this.form.date);
                formdata.append("hour", this.form.hour);

                if (this.fileList.length > 0) {
                    formdata.append("file", this.fileList[0].raw);
                }
                try {
                    this.loading = true;
                    const request = await axios({
                        url: "/events/update",
                        method: "post",
                        data: formdata,
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                    });
                    const response =
                        request.status == 200 ?
                        this.$message.success(
                            "El evento se creó correctamente"
                        ) :
                        await this.$message.warning(
                            "Error al validar datos"
                        );
                    this.isSubmitting = false;
                    this.loading = false;
                    this.initForm();
                    $("#edit-event-modal").modal("hide");
                    this.fileList = [];
                    // this.$emit(this.listarevents());
                } catch (error) {
                    this.isSubmitting = false;
                    $("#edit-event-modal").modal("hide");
                    this.loading = false;
                    console.log(error);
                }
            }
        },
    },
};
</script>
